export default "__VITE_ASSET___DGTLS5q__"